import request from '@api/request';

import type {
  GetClinicCitiesPayload,
  GetClinicCitiesResponseModel,
  GetHealthcareByIdPayload,
  GetHealthcareByIdResponseModel,
  GetHealthcareByLevel2Payload,
  GetHealthcareByLevel2ResponseModel,
  GetHealthcareByLevel4Payload,
  GetHealthcareByLevel4ResponseModel,
  GetServicesCarouselDetailPayload,
  GetServicesCarouselDetailResponseModel,
  GetServicesCarouselResponseModel,
} from '@models/clinics';
import { buildQueryParams } from '@utilities/buildQueryParams';

export const getHealthcareById = async (
  body: GetHealthcareByIdPayload,
): Promise<GetHealthcareByIdResponseModel> => {
  const params = buildQueryParams(body);
  const response = await request.get(
    `/MasterManagement/Healthcare/GetById?${params}`,
  );
  return response;
};

export const getHealthcareByLevel4 = async (
  body: GetHealthcareByLevel4Payload,
): Promise<GetHealthcareByLevel4ResponseModel> => {
  const params = buildQueryParams(body);
  const response = await request.get(
    `/MasterManagement/Healthcare/GetByLevel4?${params}`,
  );
  return response;
};

export const getHealthcareByLevel2 = async (
  body: GetHealthcareByLevel2Payload,
): Promise<GetHealthcareByLevel2ResponseModel> => {
  const params = buildQueryParams(body);
  const response = await request.get(
    `/MasterManagement/Healthcare/GetByLevel2?${params}`,
  );
  return response;
};

export const getServicesCarousel =
  async (): Promise<GetServicesCarouselResponseModel> => {
    const response = await request.get(`/ServicesCarousel/get`);
    return response;
  };

export const getServicesCarouselDetail = async (
  body: GetServicesCarouselDetailPayload,
): Promise<GetServicesCarouselDetailResponseModel> => {
  const params = buildQueryParams(body);
  const response = await request.get(`/ServicesCarousel/get-details?${params}`);
  return response;
};

export const getClinicCities = async (
  body: GetClinicCitiesPayload,
): Promise<GetClinicCitiesResponseModel> => {
  const params = buildQueryParams(body);
  const response = await request.get(`/data/v1/cities?${params}`);

  return response;
};
